import { put, call, takeLatest } from 'redux-saga/effects'
import {
    dUsersAddItemSagaAC, dUsersChangePasswordItemSagaAC, dUsersChangePINItemSagaAC,
    dUsersDeleteItemSagaAC,
    dUsersEditItemSagaAC, dUsersRecoverBulkSagaAC,
    dUsersSetDataAC,
    dUsersSetDataSagaAC, dUsersSetDetailItemAC, dUsersSetPaginationAC
} from 'model/dashboardUsers/dUsersActionCreators'
import { dashboardLoaderAC } from '../system/systemActionCreators'

import { IdUsersStateDataItem, typeUsersFilters } from 'model/dashboardUsers/dUsersReducer'


import {
    addUsersItem,
    bulkRecoverUsers, changePasswordUserItem,
    changeUsersItem,
    deleteUsersItem,
    getUsersList
} from 'model/dashboardUsers/dUsersAPI';
import { errorGenerator, notificationCreator } from 'model/system/utils';
import { paginationMapper, typePagination, typeRequestPagination } from 'model/system/constants';


// Temp data list mapper
const tempDataMapper = (tempResponseData: any): IdUsersStateDataItem[] => {
    return tempResponseData.map((item: IdUsersStateDataItem) => {
        return (
            {
                dateCreated: item.dateCreated,
                dateUpdated: item.dateUpdated,
                id: item.id,
                name: item.name,
                phoneNumber: item.phoneNumber,
                email: item.email,
                position: item.position,
                storeId: item.storeId,
                deleted: item.deleted,
                pin: item.pin,
                testCleanPin: item.testCleanPin,
                store: item.store
            }
        )
    })
}

// Get data function-generator
function* getData(payload: { filters: typeUsersFilters, paginationRequest: typeRequestPagination }) {

    let response = yield call(getUsersList, payload)

    if (response.status === 200) {

        const tempData: IdUsersStateDataItem[] = tempDataMapper(response.data.content)
        const pagination: typePagination = paginationMapper(response.data)

        yield put(dUsersSetPaginationAC(pagination))

        yield put(dUsersSetDataAC(tempData))

    } else {
        yield errorGenerator(response)
    }
}


// ---------------------------------------------------------------------------------------------------------------------
// Saga set data
export function* dUsersSetDataWorker(
    actionObject: {
        type: string,
        payload: {
            filters: typeUsersFilters,
            paginationRequest: typeRequestPagination
        }
    }
) {

    yield put(dashboardLoaderAC(true))

    yield getData(actionObject.payload)

    yield put(dashboardLoaderAC(false))

}

export function* dUsersSetDataWatcher() {
    yield takeLatest(dUsersSetDataSagaAC.type, dUsersSetDataWorker)
}

// ---------------------------------------------------------------------------------------------------------------------
// Saga add data item
export function* dUsersAddItemWorker(actionObject: {
    type: string,
    payload: {
        itemObject: {
            firstName: string,
            lastName: string,
            position: string,
            email: string,
            phoneNumber: string,
            storeId: string | null,
            password: string,
            pin: string
        },
        filters: typeUsersFilters,
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(addUsersItem, { dataObject: actionObject.payload.itemObject })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_ADD_ITEM')
        yield getData({ filters: actionObject.payload.filters, paginationRequest: actionObject.payload.paginationRequest })

    } else {
        yield errorGenerator(response)
    }
    yield put(dashboardLoaderAC(false))
}

export function* dUsersAddItemWatcher() {
    yield takeLatest(dUsersAddItemSagaAC.type, dUsersAddItemWorker)
}

// ---------------------------------------------------------------------------------------------------------------------
// // Saga edit data item
export function* dUsersEditDataItemWorker(
    actionObject: {
        type: string,
        payload: {
            detailItemObject: IdUsersStateDataItem,
            filters: typeUsersFilters,
            paginationRequest: typeRequestPagination
        }
    }
) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(changeUsersItem, { dataObject: actionObject.payload.detailItemObject })

    if (response.status === 200) {
        yield notificationCreator('SUCCESS_CHANGE_ITEM')

        yield getData({ filters: actionObject.payload.filters, paginationRequest: actionObject.payload.paginationRequest })
        if (actionObject.payload.detailItemObject.pin) {
            yield put(dUsersSetDetailItemAC(actionObject.payload.detailItemObject.id))
        }

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dUsersEditDataWatcher() {
    yield takeLatest(dUsersEditItemSagaAC.type, dUsersEditDataItemWorker)
}

// ---------------------------------------------------------------------------------------------------------------------
// Delete dashboardUsers item saga
export function* dUsersDeleteItemWorker(actionObject: {
    type: string,
    payload: { itemId: string, filters: typeUsersFilters, paginationRequest: typeRequestPagination }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(deleteUsersItem, { itemId: actionObject.payload.itemId })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_DELETE_ITEM')

        yield getData({ filters: actionObject.payload.filters , paginationRequest: actionObject.payload.paginationRequest})

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dUsersDeleteItemWatcher() {
    yield takeLatest(dUsersDeleteItemSagaAC.type, dUsersDeleteItemWorker)
}

//-----------------------------------------------------------------------------
// Saga recover bulk data
export function* dUsersRecoverBulkWorker(actionObject: {
    type: string,
    payload: {
        bulkIds: string[],
        filters: typeUsersFilters,
        paginationRequest: typeRequestPagination
    }
}) {
    yield put(dashboardLoaderAC(true))

    let response = yield call(bulkRecoverUsers, { bulkIds: actionObject.payload.bulkIds })

    if (response.status === 200) {
        yield notificationCreator('SUCCESS_RECOVER_ITEM')

        yield getData({ filters: actionObject.payload.filters, paginationRequest: actionObject.payload.paginationRequest })

    } else {
        yield errorGenerator(response)
    }
    yield put(dashboardLoaderAC(false))
}

export function* dUsersBulkRecoverWatcher() {
    yield takeLatest(dUsersRecoverBulkSagaAC.type, dUsersRecoverBulkWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// // Saga edit Password data item
export function* dUsersChangePasswordDataItemWorker(
    actionObject: {
        type: string,
        payload: {
            newPassword: string,
            emailUser: string,

        }
    }
) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(changePasswordUserItem, {
        newPassword: actionObject.payload.newPassword,
        emailUser: actionObject.payload.emailUser
    })


    if (response.status === 200) {
        yield notificationCreator('SUCCESS_CHANGE_ITEM')

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dUsersChangePasswordDataWatcher() {
    yield takeLatest(dUsersChangePasswordItemSagaAC.type, dUsersChangePasswordDataItemWorker)
}

// ---------------------------------------------------------------------------------------------------------------------
// // Saga edit data item
export function* dUsersChangePINItemWorker(
    actionObject: {
        type: string,
        payload: {
            data: {
                id: string,
                pin: string
            },

        }
    }
) {


    let response = yield call(changeUsersItem, { dataObject: actionObject.payload.data })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_CHANGE_ITEM')

    } else {
        yield errorGenerator(response)
    }

}

export function* dUsersChangePINItemWatcher() {
    yield takeLatest(dUsersChangePINItemSagaAC.type, dUsersChangePINItemWorker)
}
